var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3874 18C23.2582 18 27 17.0933 27 13.4667C27 9.84 24.1813 8.93333 21.9263 8.93333C21.747 6.66667 20.4813 1 14.5976 1C10.0877 1 7.56171 4.4 7.26894 6.66667C5.5777 6.66667 1.63153 7.23333 1.06775 11.7667C0.503963 16.3 3.5528 18 6.72774 18H7.10302",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15L14.5 11M14.5 11L18 15M14.5 11V24",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIco);
export default __webpack_public_path__ + "static/media/uploadIco.92f99e004f2a5ce7d8e9f386f49dd22b.svg";
export { ForwardRef as ReactComponent };